import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAcsVisitsIndicatorC4Data } from "@/services/esus/indicator/esf/c4/getDetailedCitizensAcsVisitsIndicatorC4";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC4CitizensAcsVisitsHistoryItem } from "./IndicatorEsfC4CitizensAcsVisitsHistoryItem";
import { IndicatorEsfC4CitizensAcsVisitsHistoryInfo } from "./IndicatorEsfC4CitizensAcsVisitsHistoryInfo";

type IndicatorEsfC4CitizensAcsVisitsHistoryProps = {
	citizenWithAcsHomeVisits: DetailedCitizenAcsVisitsIndicatorC4Data;
};

export function IndicatorEsfC4CitizensAcsVisitsHistory({
	citizenWithAcsHomeVisits,
}: Readonly<IndicatorEsfC4CitizensAcsVisitsHistoryProps>) {
	const indicatorEsfC4CitizenHistoryInfo = {
		fullName: citizenWithAcsHomeVisits.fullName ? citizenWithAcsHomeVisits.fullName : "N/A",
		birthdate: citizenWithAcsHomeVisits.birthdate
			? dayjs(citizenWithAcsHomeVisits.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAcsHomeVisits.birthdate
			? getAge(citizenWithAcsHomeVisits.birthdate)
			: "N/A",
		document: citizenWithAcsHomeVisits.cpf
			? formatIdentifier(citizenWithAcsHomeVisits.cpf)
			: citizenWithAcsHomeVisits.cns ?? "",
		motherName: citizenWithAcsHomeVisits.motherName ?? "",
		phone: citizenWithAcsHomeVisits.phone ? phoneFormat(citizenWithAcsHomeVisits.phone) : "",
		address:
			addressConcat(
				citizenWithAcsHomeVisits.street,
				citizenWithAcsHomeVisits.houseNumber,
				citizenWithAcsHomeVisits.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC4CitizensAcsVisitsHistoryInfo {...indicatorEsfC4CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Visitas"
				timeLineContents={[
					citizenWithAcsHomeVisits.firstAcsHomeVisit,
					citizenWithAcsHomeVisits.lastAcsHomeVisit,
				]
					.filter((homeVisit) => Boolean(homeVisit))
					.map((homeVisit) => homeVisit!)
					.map<TimeLineContent>((homeVisit) => {
						return {
							content: (
								<IndicatorEsfC4CitizensAcsVisitsHistoryItem homeVisit={homeVisit} />
							),
							eventDate: homeVisit.date
								? dayjs(homeVisit.date).format("DD/MM/YYYY")
								: "N/A",
						};
					})}
			/>
		</>
	);
}
